<script>
  import { setContext } from 'svelte'
  import { writable } from 'svelte/store'

  const state = writable(false)

  setContext('expansion', state)
</script>

{#if $state}
  <tr class="gl-table-expansion">
    <slot />
  </tr>
{:else}
  <slot />
{/if}
